export default function WebpageSlide({ image }) {
  return (
    <div className="slide gallery-slide gallery-accent gpad-2x row-mid-content">
      <div className="container">
        <img src={image}/>
      </div>
    </div>
  )
}